webpackJsonp([35783957827783],{

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(68);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(37);
	
	var _content = __webpack_require__(22);
	
	var _markdownComponents = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var passPropsToComponentsFromMarkup = function passPropsToComponentsFromMarkup(ast, props) {
	  var url = props.url,
	      event = props.event,
	      contactFormHandlerUrl = props.contactFormHandlerUrl,
	      googleRecaptchaSiteKey = props.googleRecaptchaSiteKey,
	      facebookAppId = props.facebookAppId;
	
	
	  ast.children.forEach(function (subAst) {
	    switch (subAst.tagName) {
	      case "event-details":
	        subAst.properties.event = JSON.stringify(event);
	        break;
	
	      case "social-buttons":
	        subAst.properties.event = JSON.stringify(event);
	        subAst.properties.url = url;
	        break;
	
	      case "facebook-comments":
	        subAst.properties.appId = facebookAppId;
	        subAst.properties.facebookEventPage = event.frontmatter.pages.facebook;
	        break;
	
	      case "show-when-facebook-page-is-present":
	        subAst.properties.facebookEventPage = event.frontmatter.pages.facebook;
	        break;
	
	      case "contact-form":
	        subAst.properties.googleRecaptchaSiteKey = googleRecaptchaSiteKey;
	        subAst.properties.contactFormHandlerUrl = contactFormHandlerUrl;
	        break;
	
	      default:
	        if (subAst.type === "element") {
	          passPropsToComponentsFromMarkup(subAst, props);
	        }
	        break;
	    }
	  });
	
	  return ast;
	};
	
	exports.default = function (_ref) {
	  var data = _ref.data,
	      location = _ref.location;
	  var page = data.page,
	      mostRecentEvent = data.mostRecentEvent;
	  var _data$site$siteMetada = data.site.siteMetadata,
	      contactFormHandlerUrl = _data$site$siteMetada.contactFormHandlerUrl,
	      googleRecaptchaSiteKey = _data$site$siteMetada.googleRecaptchaSiteKey,
	      siteUrl = _data$site$siteMetada.siteUrl,
	      facebookAppId = _data$site$siteMetada.facebookAppId;
	
	
	  var pathname = (0, _gatsbyLink.withPrefix)(location.pathname);
	  var url = "" + siteUrl + pathname;
	
	  var event = mostRecentEvent.edges[0].node;
	  var props = {
	    url: url,
	    event: event,
	    googleRecaptchaSiteKey: googleRecaptchaSiteKey,
	    facebookAppId: facebookAppId,
	    contactFormHandlerUrl: contactFormHandlerUrl
	  };
	
	  return _react2.default.createElement(
	    _content.Paper,
	    null,
	    (0, _markdownComponents.renderAst)(passPropsToComponentsFromMarkup(page.htmlAst, props))
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-fae0e2039c29c32353b0.js